import React, { useEffect } from "react";
import { Typography, Box, Paper } from "@mui/material";
import { PaySchedule } from "./PaySchedule";
import { ViewPayRun } from "./ViewPayCycleRun";
import { usePayrollCycleRun } from "./PayrollCycleRunContext";
import { useFilter } from "pages/FilterContext";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";

export const PayrollCycleRun = ({ setIsClickSchedule }) => {
  const {
    activeTab,
    setActiveTab,
    viewPayRunScreen,
    setViewPayRunScreen,
    userId,
    getUpdatedData,
    setGetUpdatedData,
    setPayScheduleData,
    payScheduleId,
  } = usePayrollCycleRun();
  const { setSelectedFilters, setFilterValues } = useFilter();
  const { domain, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );

  useEffect(() => {
    const getUpdatedPayScheduleData = async () => {
      const url = `${domain}payroll/operations/payrollprocessing/payrollruncycle/payschedules/?status=Run&company_id=${topbarCompanyId}`;
      const res = await customGetAPI(url);
      if (res.ok) {
        const updatedItem = res?.responseDetails?.find(
          (item) => item.id === payScheduleId
        );
        setPayScheduleData(updatedItem);
      } else {
        setPayScheduleData([]);
      }
    };
    if (getUpdatedData) {
      getUpdatedPayScheduleData();
      setGetUpdatedData(false);
    }
  }, [
    domain,
    getUpdatedData,
    payScheduleId,
    setGetUpdatedData,
    setPayScheduleData,
    topbarCompanyId,
  ]);
  return (
    <>
      {viewPayRunScreen ? (
        <>
          <Box>
            <ViewPayRun userId={userId} />
          </Box>
        </>
      ) : (
        <>
          <Box>
            <Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                  Payroll Cycle Run
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Exceute complete payroll processing for the selected period,
                  covering employee earnings, deductions, and approvals.
                </Typography>
              </Box>

              <Box>
                <Box sx={{ display: "flex", gap: 2, ml: 5 }}>
                  <Box
                    sx={{
                      padding: "12px 24px",
                      backgroundColor:
                        activeTab === 0 ? "white" : "transparent",
                      color:
                        activeTab === 0 ? "primary.main" : "text.secondary",
                      fontWeight: 600,
                      cursor: "pointer",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      marginBottom: "-1px",
                      "&:hover": {
                        backgroundColor:
                          activeTab === 0 ? "white" : "transparent",
                      },
                    }}
                    onClick={() => {
                      setActiveTab(0);
                      setSelectedFilters([]);
                      setFilterValues({});
                    }}
                  >
                    Run
                  </Box>

                  <Box
                    sx={{
                      padding: "12px 24px",
                      backgroundColor:
                        activeTab === 1 ? "white" : "transparent",
                      color:
                        activeTab === 1 ? "primary.main" : "text.secondary",
                      fontWeight: 600,
                      cursor: "pointer",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      marginBottom: "-1px",
                      "&:hover": {
                        backgroundColor:
                          activeTab === 1 ? "white" : "transparent",
                      },
                    }}
                    onClick={() => {
                      setActiveTab(1);
                      setSelectedFilters([]);
                      setFilterValues({});
                    }}
                  >
                    Awaiting Approval
                  </Box>

                  <Box
                    sx={{
                      padding: "12px 24px",
                      backgroundColor:
                        activeTab === 2 ? "white" : "transparent",
                      color:
                        activeTab === 2 ? "primary.main" : "text.secondary",
                      fontWeight: 600,
                      cursor: "pointer",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      marginBottom: "-1px",
                      "&:hover": {
                        backgroundColor:
                          activeTab === 2 ? "white" : "transparent",
                      },
                    }}
                    onClick={() => {
                      setActiveTab(2);
                      setSelectedFilters([]);
                      setFilterValues({});
                    }}
                  >
                    Completed
                  </Box>
                </Box>
              </Box>
            </Box>

            <Paper sx={{ width: "100%", height: "89vh" }}>
              <PaySchedule
                activeTab={activeTab}
                setViewPayRunScreen={setViewPayRunScreen}
                setIsClickSchedule={setIsClickSchedule}
                getUpdatedData={getUpdatedData}
                setGetUpdatedData={setGetUpdatedData}
              />
            </Paper>
          </Box>
        </>
      )}
    </>
  );
};
